import { IFormController, IPromise } from 'angular';
import { UserService } from '../../../../tn.user/service.tn.user';
import { IRootScope } from '../../../classes/Model/RootScope';
import template from './popover-login.html';

// this is a login component meant to be used in our standard inline popovers.
// this should be replaced with a state driven popover that redirects to the oidc site.

export class PopoverLogin {
    onLogin?: () => void;
    email = '';
    password = '';
    signinForm?: IFormController;
    errors: { unauthorized?: boolean } = {};

    static $inject = ['$rootScope', 'tn.user.service'];
    constructor(
        protected $rootScope: IRootScope,
        protected userService: UserService
    ) {
        // go ahead and do whatever we should do onLogin if the user is already logged in.
        userService.ready.then(() => {
            if (userService.isLoggedIn()) {
                this.onLogin && this.onLogin();
            }
        });
    }

    signin(): IPromise<void> {
        return this.userService.oauthLogin();
    }
}

export const PopoverLoginComponent = {
    controller: PopoverLogin,
    transclude: true,
    template,
    bindings: {
        onLogin: '&',
    },
};
